import r from "../../managers/braze-instance.js";
import { hideContentCards, showContentCards } from "../index.js";
export function toggleContentCards(e, n) {
  r.rr() && (document.querySelectorAll(".ab-feed").length > 0 ? hideContentCards() : showContentCards(e, n));
}